import React, { createContext, useEffect, useState } from 'react';
import {
  apiReponseError,
  apiRequestError,
  clearSessionStorage,
  getAppRoutePagePaths,
  isNullOrWhiteSpace,
  isValidJSONString
} from '../utils/helper';

import packageInfo from '../../package.json';
import API from '../utils/api';

const moment = require("moment");

const initialESPJobs: ESPJob[] = [{ espJobKey: "", name: "", runStatusDescription: "", lastModifiedBy: "", lastModifiedDate: null, lastTriggeredBy: "", lastTriggeredDate: null, runStatus: true, note: "", pendingCount: 0, lastProcessDate: null, listRoutePath: "", uploadRoutePath: "", canRead: false, canWrite: false, reviewCount: 0, triggerFileExists: false }];
const initialAppSetting: AppSetting = { online: true, meshifyUrl: "", legacyEnlistmentUrl: "" };
const initialAdminUsers: AdminUser[] = [{ firstName: "", lastLoginDate: "", lastName: "", roles: [{ roleKey: "", roleName: "", userRoleKey: "" }], userId: "", userKey: "", isInternal: false }];
const initialAppPagePaths: AppPagePath[] = [{ title: "", path: "", note: "", key: "" }];
const initialAppRoutePaths: AppRoutePath[] = [{ title: "", path: "", note: "", paths: initialAppPagePaths }];
const initialClientCompanies: ClientCompany[] = [{ active: false, address: { addressline1: "", addressline2: "", addressline3: "", country: "", locality1: "", locality2: "", postalCode: "", region1: "", region2: "" }, changeProgram: false, clientCompanyKey: "", dcxSiteId: "", enableEnlistment: false, enlistmentSiteManageByAEM: false, enrollmentCount: 0, hsbPartnerId: "", lastModifiedBy: "", lastModifiedDateTime: "", name: "", parentKey: "", parentName: "", partnerType: "", programCount: 0, routingName: "", shortName: "", folderId: 0, parentFolderId: 0, apiKey: "" }];
const initialDeviceLocationGroup: DeviceLocationGroup[] = [{ groupPrefix: "", deviceLocations: [{ deviceLocationKey: "", name: "" }] }];
const initialKits: Kit[] = [{ active: false, committmentPeriod: 0, fulfillmentVendorKey: "", fulfillmentVendorName: "", hsbKitNo: 0, kitItemCount: 0, kitKey: "", lastModifiedBy: "", lastModifiedDateTime: "", name: "", platformVendorKey: "", platformVendorName: "", programCodes: "", programCount: 0, rechargeDiscountCode: "", replacementKit: false, subscriptionBilling: false, enrollmentCount: 0 ,defaultInstallMethodId :"" }];
const initialPrograms: Program[] = [{ active: false, address: { addressline1: "", addressline2: "", addressline3: "", country: "", locality1: "", locality2: "", postalCode: "", region1: "", region2: "" }, aemSiteId: "", autoEnroll: false, defaultPackageId: 0, enableEnlistment: false, enableSubscriptionBilling: false, enrollmentCount: 0, folderId: 0, clientCompanyKey: "", lastModifiedBy: "", lastModifiedDateTime: "", enlistmentSiteManageByAEM: false, maxAccountCanBeRegister: 0, meshifyDomainName: "", parentName: "", partnerDCXSiteId: "", programCode: 0, programKey: "", programName: "", programPartnerId: "", routingName: "", sendToPSFIN: false, shopifyLandingPage: "", showAgreementConfirmation: false, totalPilotAccountForRegistration: 0, uniqueDCXSite: false, showInEnlistmentProductLookup: false, enlistmentProgramGroupCode: "", isEnlistmentCustomerSite: false, enableParentEnlistment: false, parentRoutingName: "", readyToEnroll: false, readyToEnrollApprovedBy: "", readyToEnrollApprovedDate: "", taxExempt: false, showKits: false, whiskerGroupId: 0, whiskerGroupType: "" },];
const initialReferenceLookups: ReferenceLookups = { countries: [{ code: "", name: "", states: [{ code: "", name: "" }] }], clientCompanies: [{ clientCompanyKey: "", hsbPartnerId: "", name: "", shortName: "", active: false }], deviceOwnerships: [{ deviceOwnershipKey: "", name: "" }], skus: [{ name: "", partNumber: "", skuKey: "", vendorName: "", vendorKey: "", skuType: "", fulfillable: false, category: "" }], newRecordDefaultId: "", combinedCompanyDefaultId: "", parentCompanies: [{ parentKey: "", name: "" }], participantFolderCount: 0, programs: [{ programKey: "", programName: "", hsbPartnerId: "", clientCompanyKey: "", programCode: "", taxExempt: false, active: false }], vendors: [{ vendorKey: "", name: "" }], domains: [{ id: 0, fqdn: "" }], roles: [{ name: "", roleKey: "", categoryName: "", accessibility: -1, categoryNote: "" }], notificationSchemas: [{ id: 0, name: "" }], deviceLocationNotificationSchemaValidations: [{ deviceLocationName: "", notificationSchemaName: "", required: false }], programBillingMethodTypes: [{ type: "", name: "" }], billableFolderTypes: [{ value: 0, text: "" }], locationtypes: [{ value: 0, text: "" }],supportLevel: [{ value: 0, text: "" }], kits: [{ kitKey: "", name: "", hsbKitNo: 0, devices: [{ deviceKey: "", name: "", quantity: 0 }] }], };
const initialReplacementOrders: ReplacementOrder[] = [{ accountName: "", accountNumber: "", companyCode: "", dqPassed: false, folderId: 0, installOption: "", isValidationSuccess: false, kitNo: 0, modifiedDate: "", programCode: "", replacementOrderCompletedDate: "", replacementOrderKey: "", replacementOrderShortOrderId: 0, shipping: { address: { addressline1: "", addressline2: "", addressline3: "", country: "", locality1: "", locality2: "", postalCode: "", region1: "", region2: "" }, email: "", firstName: "", lastName: "", organizationName: "", phone: "" }, shippingAddressAutoCorrectedByDQ: false, validationMessage: "" }];
const initialSKUs: SKU[] = [{ isDevice: false, fulfillable: true, lastModifiedBy: "", lastModifiedDateTime: "", kitCount: 0, name: "", nodeReferenceName: "", partNumber: "", skuKey: "", vendorName: "", vendorKey: "", enrollmentCount: 0 }];
const initialSubscriptions: Subscription[] = [{ accountName: "", accountSubscriptionId: 0, clientAccountNumber: "", clientCompanyName: "", contactEmail: "", contactFirstName: "", contactLastName: "", createdDate: "", expiredCount: 0, kitNNo: 0, locked: false, modifiedBy: "", modifiedDate: "", programCode: "", programName: "", replacementKit: false, state: "", status: "", statusDate: "", subscriptionKey: "" }];
const initialUserFunctionAccess: UserFunctionAccess = { crmBatchAdminRead: false, crmBatchAdminWrite: false, deviceLocationRead: false, deviceLocationWrite: false, enlistmentAdminRead: false, enlistmentAdminWrite: false, enrollmentBatchAdminRead: false, enrollmentBatchAdminWrite: false, fulfillmentBatchAdminRead: false, fulfillmentBatchAdminWrite: false, manualOrderAdmin: false, manualOrderSubmitter: false, onboardingCompanyAdminRead: false, onboardingCompanyAdminWrite: false, onboardingKitAdminRead: false, onboardingKitAdminWrite: false, onboardingKitApprover: false, onboardingProgramAdminRead: false, onboardingProgramAdminWrite: false, pendingEnrollmentRead: false, pendingEnrollmentWrite: false, replacementAdminRead: false, replacementAdminWrite: false, skuAdminRead: false, skuAdminWrite: false, statusBatchAdminRead: false, statusBatchAdminWrite: false, subscriptionAdminRead: false, subscriptionAdminWrite: false, userPermissionAdmin: false, validation: false, weatherBatchAdminRead: false, weatherBatchAdminWrite: false, preEnrollmentBatchAdminWrite: false, preEnrollmentBatchAdminRead: false, savesWrite: false, savesRead: false, contractOrderWrite: false, contractOrderRead: false, iTTeam: false, preOrderRead: false, preOrderWrite: false, accountOptoutRead: false, accountOptoutWrite: false };
const initialUserValues: UserType = { information: { first: "Not Logged Id", last: "" }, email: "" };
const initialProgramOtherAttribute: ProgramOtherAttribute = { metadata: { programBillingMethod: "", passShipToPhoneToShopify: false, subscribeToInstallationAlert: false, whiskerGroupId: "", billableFolderId: -1, whiskerGroupType: "" }, theme: { clientCompanyPath: "", clientCompanyURL: "", companyName: "", enlistmentFavicon: "", enlistmentMainPageBackgroundImage: "", phoneNumber: "", preEnrollmentSupportEmail: "", preEnrollmentSupportPhone: "", programPath: "", participantionAgreementUrl: "", companyLogo: "",locationType: "",supportLevel:"", defaultSchemas: [""], deviceLocations: [""], emailURL: "", logoUrl: "", primaryColor: "", primaryTextColor: "", secondaryColor: "", secondaryTextColor: "", sensorStoreLink: false, shopifyDiscountCode: "", showLogo: false, supportNumber: "", warranties: [{ warrantyNumber: "", warrantyType: "" }], waveColor: "", waveOpacity: 0.0 }, publicPaths: [""], privatePaths: [""] };
const initialOnboardingProgram: OnboardingProgram = { company: initialClientCompanies[0], program: initialPrograms[0], kits: [{ kitKey: "", kitProgramKey: "", hsbKitNo: 0, name: "", subscriptionBilling: false, replacementKit: false, committmentPeriod: 0, active: false, kitItems: [{ kitItemKey: "", name: "", partNumber: "", platformVendorName: "", deviceOwnership: "", subscriptionBilling: false, quantity: 0, rollupItem: false, fulfillable: false }] }], programOtherAttribute: initialProgramOtherAttribute, validationResults: [{ name: "", resultItems: [{ note: "", referenceKey: "", referenceType: "", type: "" }] }] };
const initialPendingEnrollmentCompanies: PendingEnrollmentCompany[] = [{ companyKey: "", companyCode: "", companyName: "", fileCount: 0, recordCount: 0, pendingCount: 0, inQueueCount: 0, holdCount: 0 }];
const initialEnlistmentPartners: EnlistmentPartner[] = [{ name: "", partnerKey: "", pendingCount: 0, programs: [{ name: "", programKey: "", pendingCount: 0, statusLookupValues: [{ name: "", value: "" }] }] }];
const initialEnrollmentBatches: EnrollmentBatch[] = [{ userKey: "", username: "", enrollmentBatchFiles: [{ preBatchLoadKey: "", lastUpdateBy: "", lastUpdateDate: "", clientCode: "", clientName: "", inputFileName: "", ready: 0, skipEnrollment: 0, inQueue: 0, totalRecord: 0, isProcessCompleted: true, statusName: "", fileId: 0 }] }];
const initialUserActionPendings: UserActionPendingItem[] = [];

//----------------------------------------
// App global context
//----------------------------------------
export const AppContext = createContext({
  adminUsers: initialAdminUsers,
  appStatus: { locked: false, message: "", bulletinMessage: "", bulletinTitle: "", note: "" },
  appDataReady: false,
  appReady: false,
  appRoutePaths: initialAppRoutePaths,
  appSetting: initialAppSetting,
  appVersionMisMatch: false,
  checkAutoLogin: (): any => { },
  clientCompanies: initialClientCompanies,
  contentDataLoading: false,
  dataError: "",
  deviceLocationGroup: initialDeviceLocationGroup,
  enlistmentPartnerKey: "",
  enlistmentPartners: initialEnlistmentPartners,
  enlistmentProgramKey: "",
  enlistmentStatus: "pending",
  espJobs: initialESPJobs,
  enrollmentBatches: initialEnrollmentBatches,
  hideAlert: () => { },
  internal: false,
  isUserAuthenticated: false,
  jobPagePathName: "",
  kits: initialKits,
  logoff: () => { },
  onboardingDataRefreshInProgress: false,
  onboardingPagePathName: "Companies",
  onboardingProgram360Data: initialOnboardingProgram,
  pendingEnrollmentCompanies: initialPendingEnrollmentCompanies,
  programKey: "",
  programs: initialPrograms,
  referenceLookups: initialReferenceLookups,
  refreshData: (name: string) => { },
  replacementOrders: initialReplacementOrders,
  setAppReady: (ready: boolean) => { },
  savesEntityKey: "",
  setSavesEntityKey: (key: string) => { },
  setEnlistmentKeys: (paramEnlistmentPartnerKey: string, paramEnlistmentProgramKey: string, paramEnlistmentStatus: string) => { },
  setJobPagePathName: (PagePathName: string) => { },
  setOnboardingPagePathName: (PagePathName: string) => { },
  setProgram360ProgramKey: (key: string) => { },
  setReplacementOrders: (data: ReplacementOrder[]) => { },
  setSubscriptions: (data: Subscription[]) => { },
  setThemeType: (type: string) => { },
  showAlert: (props: SnackbarAlertProps) => { },
  skus: initialSKUs,
  snackbarAlertOpen: false,
  snackbarAlertProps: { message: "", severity: "success" },
  subscriptions: initialSubscriptions,
  themeType: "",
  user: initialUserValues,
  userFunctionAccess: initialUserFunctionAccess,
  userActionPendings: initialUserActionPendings,
  validateLoginUser: (email: string, pwd: string, rememberMe: boolean) => { },
  writeLog: (title: string, note: string, referenceCode: string, referenceType: string) => { },
  userSelectedProgramCodesNote: ""
});

// Create a provider for components to consume and subscribe to changes
export const AppContextProvider: React.FC<React.ReactNode> = ({ children }) => {
  const [internal, setInternal] = useState<boolean>(false);
  const [passwordRememberMe, setPasswordRememberMe] = useState<boolean>(false);
  const [enlistmentPartners, setEnlistmentPartners] = useState<EnlistmentPartner[]>(initialEnlistmentPartners);
  const [appVersionMisMatch, setAppVersionMisMatch] = useState<boolean>(false);
  const [espJobs, setESPJobs] = useState<ESPJob[]>(initialESPJobs);
  const [adminUsers, setAdminUsers] = useState<AdminUser[]>([]);
  const [appDataReady, setAppDataReady] = useState<boolean>(false);
  const [appReady, setAppReady] = useState<boolean>(false);
  const [appRoutePaths, setAppRoutePaths] = useState<AppRoutePath[]>([]);
  const [appSetting, setAppSetting] = useState<AppSetting>(initialAppSetting);
  const [clientCompanies, setClientCompanies] = useState<ClientCompany[]>([]);
  const [contentDataLoading, setContentDataLoading] = useState<boolean>(false);
  const [dataError, setDataError] = useState<string>("");
  const [deviceLocationGroup, setDeviceLocationGroup] = useState<DeviceLocationGroup[]>([]);
  const [isUserAuthenticated, setIsUserAuthenticated] = useState<boolean>(false);
  const [jobPagePathName, setJobPagePathName] = useState<string>("");
  const [kits, setKits] = useState<Kit[]>([]);
  const [onboardingPagePathName, setOnboardingPagePathName] = useState<string>("");
  const [programs, setPrograms] = useState<Program[]>([]);
  const [referenceLookups, setReferenceLookups] = useState<ReferenceLookups>(initialReferenceLookups);
  const [replacementOrders, setReplacementOrders] = useState<ReplacementOrder[]>([]);
  const [skus, setSKUs] = useState<SKU[]>([]);
  const [snackbarAlertOpen, setSnackbarAlertOpen] = useState<boolean>(false);
  const [snackbarAlertProps, setSnackbarAlertProps] = useState<SnackbarAlertProps>({ message: "", severity: "success" });
  const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);
  const [themeType, setThemeType] = useState<string>("light");
  const [user, setUser] = useState<UserType>(initialUserValues);
  const [userFunctionAccess, setUserFunctionAccess] = useState<UserFunctionAccess>(initialUserFunctionAccess);
  const [onboardingDataRefreshInProgress, setOnboardingDataRefreshInProgress] = useState<boolean>(false);
  const [programKey, setProgramKey] = useState<string>("");
  const [onboardingProgram360Data, setOnboardingProgram360Data] = useState<OnboardingProgram>(initialOnboardingProgram);
  const [pendingEnrollmentCompanies, setPendingEnrollmentCompanies] = useState<PendingEnrollmentCompany[]>(initialPendingEnrollmentCompanies);
  const [enrollmentBatches, setEnrollmentBatches] = useState<EnrollmentBatch[]>(initialEnrollmentBatches);
  const [enlistmentPartnerKey, setEnlistmentPartnerKey] = useState<string>("");
  const [enlistmentProgramKey, setEnlistmentProgramKey] = useState<string>("");
  const [enlistmentStatus, setEnlistmentStatus] = useState<string>("Pending");
  const [appStatus, setAppStatus] = useState<AppLockedStatus>({ locked: false, message: "", bulletinMessage: "", bulletinTitle: "", note: "" });
  const [savesEntityKey, setSavesEntityKey] = useState("");
  const [userActionPendings, setUserActionPendings] = useState<UserActionPendingItem[]>([]);
  const [userSelectedProgramCodesNote, setUserSelectedProgramCodesNote] = useState("");

  let locked = false;
  let appLogCounter = 0;
  let appLogInProgress = false;

  // Initializing login user and application related data
  useEffect(() => {
    const initAsync = async () => {
      setUser(initialUserValues);
    };
    initAsync();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logUserAgent = () => {
    try {
      const userAgent = window.navigator.userAgent;
      writeLog("UserAgent", userAgent, "", "");
    } catch (e) { }
  };
  // Show alert message
  const showAlert = (props: SnackbarAlertProps) => {
    setSnackbarAlertProps(props);
    setSnackbarAlertOpen(true);
  };

  // Hide alert message
  const hideAlert = () => {
    setSnackbarAlertOpen(false);
  };

  // Get token (json object) from local storage
  const getLocalStorageToken = () => {
    try {
      const authToken: any = localStorage.getItem("AuthToken");
      if (!isNullOrWhiteSpace(authToken)) {
        return JSON.parse(authToken);
      }
    } catch (e) { }
    return "";
  };

  const getXRequestId = () => {
    let returnValue = "";
    try {
      const cookies = document.cookie.split(';');
      for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split('=');
        if (cookieName.trim() === "X-Browser-Id") {
          const decodeCookieValue = decodeURIComponent(cookieValue);
          if (decodeCookieValue !== null && decodeCookieValue !== undefined && decodeCookieValue !== "") {
            returnValue = atob(decodeCookieValue);
          }
        }
      }
    }
    catch { };
    return returnValue;
  }

  // Save auto token in the local
  const saveAuthToken = (mode: number, data: any, rememberMe: boolean) => {
    const newData = {
      accessToken: data.accessToken,
      expireIn: data.expireIn,
      refreshToken: data.refreshToken,
      requestId: getXRequestId()
    }

    if (mode === 1) {
      sessionStorage.setItem("SessionAuthToken", JSON.stringify(newData));
      if (rememberMe) {
        localStorage.setItem("AuthToken", JSON.stringify(newData));
      }
    } else {
      sessionStorage.setItem("SessionAuthToken", JSON.stringify(newData));
      if (rememberMe) {
        localStorage.setItem("AuthToken", JSON.stringify(newData));
      }
    }
    let expireIn = 25;
    try {
      expireIn = Number(data.expireIn) - 5;
      if (expireIn > 25) {
        expireIn = 25;
      }
    } catch (e) { }
    setTimeout(() => {
      refreshToken(data);
    }, expireIn * 60000);
  };

  // Refresh auth token in specified interval
  const refreshToken = async (authToken: any) => {
    if (authToken !== "") {
      writeLog("Login", "Refreshing token", "", "");

      const payload = { accessToken: authToken.accessToken, refreshToken: authToken.refreshToken };
      try {
        setDataError("");
        await API.post("/api/auth/autosign", payload)
          .then(async (response) => {
            writeLog("Login", "Successfully refresh the token", "", "");
            if (isValidJSONString(response.data)) {
              saveAuthToken(0, response.data, passwordRememberMe);
              await getAppStatus();
              setIsUserAuthenticated(true);
            }
          })
          .catch((error) => {
            writeLog("Login", "Refresh token failed", "", "");
            setIsUserAuthenticated(false);
            if (error?.response?.status === 404) {
              setDataError("Something was wrong in our system.");
            } else if (error?.response?.status === 401) {
              setDataError(error.response?.data.message);
            } else if (error?.response?.status === 403) {
              setDataError("The server you have attempted to reach is currently stopped and does not accept any requests. Please try to reload the page or visit it again soon.");
              showAlert({ message: "The server you have attempted to reach is currently stopped and does not accept any requests. Please try to reload the page or visit it again soon.", severity: "error" });
            } else if (error?.response?.status === 500) {
              setDataError(error.response.statusText);
            }
          });
      } catch (e) { }
    }
  };

  // Validating auto login (if token exists in local storage)
  const checkAutoLogin = async (): Promise<boolean> => {
    if (isUserAuthenticated) {
      return true;
    }

    if (contentDataLoading) {
      return true;
    }

    clearSessionStorage();

    writeLog("Login", "Checking auto login", "", "");
    const authToken: any = getLocalStorageToken();
    if (authToken !== "") {
      const payload = { accessToken: authToken.accessToken, refreshToken: authToken.refreshToken };
      try {
        setDataError("");
        await API.post("/api/auth/autosign", payload)
          .then(async (response) => {
            if (isValidJSONString(response.data)) {
              writeLog("Login", "Successfully login", "", "");
              saveAuthToken(0, response.data, true);

              writeLog("App Start", "Checking app status.", "", "");
              await getAppStatus();

              await initialDataLoad();
              setIsUserAuthenticated(true);
              writeLog("Login", "Successfully login.", "", "");

              return true;
            }
          })
          .catch((error) => {
            setIsUserAuthenticated(false);
            if (error?.response?.status === 404) {
              setDataError("Something was wrong in our system.");
            } else if (error?.response?.status === 401) {
              setDataError(error.response?.data.message);
            } else if (error?.response?.status === 403) {
              setDataError("The server you have attempted to reach is currently stopped and does not accept any requests. Please try to reload the page or visit it again soon.");
              showAlert({ message: "The server you have attempted to reach is currently stopped and does not accept any requests. Please try to reload the page or visit it again soon.", severity: "error" });
            } else if (error?.response?.status === 500) {
              setDataError(error.response.statusText);
            }
          });
      } catch (e) { }
    }
    return false;
  };

  // Validate user token
  const validateUserToken = async (username: string, pwd: string, rememberMe: boolean) => {
    const payload = { username: username, password: pwd };

    let confirm = false;
    if (isUserAuthenticated) {
      return true;
    }

    clearSessionStorage();

    writeLog("Login", "Validation the user cerditional.", "", "");
    setContentDataLoading(true);

    try {
      setDataError("");
      await API.post("/api/auth/token", payload)
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setPasswordRememberMe(rememberMe);
            saveAuthToken(1, response.data, rememberMe);

            writeLog("App Start", "Checking app status.", "", "");
            await getAppStatus();

            await initialDataLoad();
            setIsUserAuthenticated(true);
            writeLog("Login", "Successfully login.", "", "");

            confirm = true;
          } else {
            setDataError("Something was wrong in our system.");
            setIsUserAuthenticated(false);
          }
        })
        .catch((error) => {
          if (error?.response?.status === 404) {
            setDataError("Something was wrong in our system.");
            setIsUserAuthenticated(false);
          } else if (error?.response?.status === 401) {
            const errorDetail = error.response?.data.message;

            if (errorDetail !== "" && errorDetail !== null && errorDetail.length > 50) {
              setDataError(errorDetail + ".");
            } else {
              setDataError("The combination of email and password you have entered is incorrect.");
            }
            setIsUserAuthenticated(false);
          } else if (error?.response?.status === 403) {
            setDataError("The server you have attempted to reach is currently stopped and does not accept any requests. Please try to reload the page or visit it again soon.");
            showAlert({ message: "The server you have attempted to reach is currently stopped and does not accept any requests. Please try to reload the page or visit it again soon.", severity: "error" });
            setIsUserAuthenticated(false);
          } else {
            clearToken();
            setDataError("The combination of email and password you have entered is incorrect.");
          }
        });
    } catch (e) {
      if (!window.navigator.onLine) {
        setDataError("There is no internet connection. Please check your network.");
        setIsUserAuthenticated(false);
      } else {
        setDataError("Something was wrong in our system.");
        setIsUserAuthenticated(false);
      }
    }
    setContentDataLoading(false);
    return confirm;
  };

  // Validate user with username & pwd
  const validateLoginUser = async (email: string, pwd: string, rememberMe: boolean) => {
    return Promise.resolve(await validateUserToken(email, pwd, rememberMe));
  };

  // Set internet connection available or not
  const setOnline = (trueFalse: boolean) => {
    setAppSetting({ ...appSetting, online: trueFalse });
  };

  // Onboard data refresh
  const refreshData = async (name: string) => {
    let loadGetReferenceLookups = true;

    getAppStatus();

    setOnboardingDataRefreshInProgress(true);

    writeLog("Refresh Data", "Refreshing " + name, "", "");

    name = name.replaceAll(" ", "");

    if (name.toLowerCase() === "appstatus") {
      await getAppStatus();
      setOnboardingDataRefreshInProgress(false);
      return;
    } else if (name.toLowerCase() === "useractions") {
      await getUserActions();
      setOnboardingDataRefreshInProgress(false);
      return;
    } else if (name.toLowerCase() === "companies") {
      setClientCompanies([]);
      await getClientCompanies();
    } else if (name.toLowerCase() === "programs") {
      setPrograms([]);
      await getPrograms();
    } else if (name.toLowerCase() === "adminuser") {
      setAdminUsers([]);
      await getAdminUsers();
      loadGetReferenceLookups = false;
    } else if (name.toLowerCase() === "kits") {
      setKits([]);
      await getKits();
    } else if (name.toLowerCase() === "skus") {
      setSKUs([]);
      await getSKUs();
    } else if (name.toLowerCase() === "devicelocations") {
      setDeviceLocationGroup([]);
      await getDeviceLocations();
    } else if (name.toLowerCase() === "program360") {
      if (programKey !== "") {
        await getProgram360Data(programKey);
        loadGetReferenceLookups = false;
      }
    } else if (name.toLowerCase() === "espjob") {
      await getESPJobs();
    } else if (name.toLowerCase() === "pec") {
      await getPendingEnrollmentCompanies();
    } else if (name.toLowerCase() === "enlistmentpartners") {
      await getEnlistmentPartners();
    } else if (name.toLowerCase() === "enrollmentbatches") {
      await getEnrollmentBatches();
      loadGetReferenceLookups = false;
    }

    setOnboardingDataRefreshInProgress(false);

    if (programKey !== "" && name.toLowerCase() !== "program360") {
      getProgram360Data(programKey);
    }

    if (loadGetReferenceLookups) {
      getReferenceLookups();
      getUserActions();
    }
  };

  // initialized data load after successfully login
  const initialAppDataLoad = async () => {
    writeLog("App Start", "Initializing App Data", "", "");

    window.addEventListener("offline", function (e) {
      setOnline(false);
    });

    window.addEventListener("online", function (e) {
      setOnline(true);
    });

    setOnboardingDataRefreshInProgress(true);

    await Promise.all([getClientCompanies(), getPrograms(), getKits(), getDeviceLocations(), getSKUs(), getAdminUsers(), getESPJobs(), getPendingEnrollmentCompanies(), getEnlistmentPartners(), getEnrollmentBatches()]).then((values) => {
      setAppDataReady(true);
      setOnboardingDataRefreshInProgress(false);
    });

    writeDBLog();
  };

  // Initialized data load after successfully login
  const initialDataLoad = async () => {
    logUserAgent();

    if (!locked) {
      writeLog("App Start", "Initializing user access, routing & reference lookups", "", "");
      await Promise.all([getReferenceLookups(), getAppRoutePaths(), getUserAccess(), getUserMe(), getUserActions()]).then((values) => {
        setTimeout(async () => {
          await initialAppDataLoad();
        }, 10000);
      });
    } else {
      //goToRoutePage("locked");
      //navigate("locked", { replace: true });
    }
  };

  // Write app log to sesssion storage
  const writeLog = async (title: string, note: string, referenceCode: string, referenceType: string) => {
    appLogCounter++;
    const captureDate = moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSSSSS") + "Z";
    const key = moment.utc().valueOf() + "-" + appLogCounter;
    const newLog = { title, note, referenceCode, referenceType, captureDate };
    sessionStorage.setItem("log-" + key, JSON.stringify(newLog));
    await writeDBLog();
  };

  // Get all log session storage name
  const getAllLogSessionStorageNames = () => {
    let sessionStorageKeyNames: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const sessionStorageKeyName = sessionStorage.key(i);
      if (sessionStorageKeyName !== null && sessionStorageKeyName !== undefined) {
        if (sessionStorageKeyName.toLowerCase().indexOf("log-") >= 0) {
          sessionStorageKeyNames.push(sessionStorageKeyName as string);
        }
      }
    }
    sessionStorageKeyNames = sessionStorageKeyNames.sort();
    return sessionStorageKeyNames;
  };

  // Insert log to database
  const writeDBLog = async () => {
    if (appLogInProgress) {
      return;
    }

    appLogInProgress = true;

    if (isUserAuthenticated) {
      try {
        const sessionStorageKeyNames: string[] = getAllLogSessionStorageNames();
        const applogs: AppLog[] = [];

        for (let i = 0; i < sessionStorageKeyNames.length; i++) {
          const sessionStorageKeyName = sessionStorageKeyNames[i];
          try {
            const log = sessionStorage.getItem(sessionStorageKeyName);
            if (log !== undefined && log !== null && log.length > 0) {
              const logJSON = JSON.parse(log);
              applogs.push(logJSON as AppLog);
            }
          } catch (e) { }
          try {
            sessionStorage.removeItem(sessionStorageKeyName);
          } catch (e) { }
        }

        if (applogs.length > 0) {
          await insertAppLog(applogs);
        }
      } catch (e) { }
    }

    appLogInProgress = false;
  };

  //Insert app log
  const insertAppLog = async (appLogs: AppLog[]) => {
    const payload = {
      appLogs: appLogs,
    };

    try {
      await API.post("/api/log", payload)
        .then(async (response) => { })
        .catch((error) => { });
    } catch (e) { }
  };

  // Get user access information
  const getUserAccess = async (): Promise<UserFunctionAccess> => {
    writeLog("User Access", "Fetching requested data via api.", "", "");
    const tempUserFunctionAccess: UserFunctionAccess = initialUserFunctionAccess;
    try {
      await API.get("/api/admin/users/access")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            try {
              setInternal(response.data.isInternal);
              setUserSelectedProgramCodesNote(response.data.userSelectedProgramCodesNote);
              if (response.data.isInternal) {
                getESPJobs2(response.data.isInternal);
              }

              const functionNames = response.data.functionNames;
              Object.keys(tempUserFunctionAccess).forEach((key) => {
                if (functionNames.indexOf(key) >= 0) {
                  tempUserFunctionAccess[key] = true;
                }
              });
            } catch (e) { }
          } else {
            setDataError("Something was wrong in our system.");
          }

          setUserFunctionAccess(tempUserFunctionAccess);
        })
        .catch((error) => {
          setDataError(apiReponseError(error, "Login user information missing."));
        });
    } catch (e) {
      setDataError(apiRequestError(e, "Something was wrong in our system."));
    }

    return tempUserFunctionAccess;
  };

  const greetingUser = (name) => {
    try {
      const currentHour = new Date().getHours();
      let message = ""
      if (currentHour >= 5 && currentHour < 12) {
        message = 'Good morning, ' + name;
      } else if (currentHour >= 12 && currentHour < 18) {
        message = 'Good afternoon, ' + name;
      } else {
        message = 'Good evening, ' + name;
      }
      showAlert({ message: message, severity: "info", });
    }
    catch { }
  }

  // Get user information
  const getUserMe = async (): Promise<boolean> => {
    writeLog("User Me", "Fetching requested data via api.", "", "");
    let success = false;
    try {
      await API.get("/api/admin/users/me")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setUser(response.data.user);
            greetingUser(response.data.user.information.first);
            success = true;
          } else {
            setDataError("Something was wrong in our system.");
          }
        })
        .catch((error) => {
          setDataError(apiReponseError(error, "Login user information missing."));
        });
    } catch (e) {
      setDataError(apiRequestError(e, "Something was wrong in our system."));
    }
    return success;
  };

  // Get app status
  const getAppStatus = async (): Promise<boolean> => {
    writeLog("App Status", "Fetching requested data via api.", "", "");
    locked = false;
    try {
      await API.get("/api/auth/appstatus")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setAppStatus({ locked: response.data.locked, message: response.data.message, bulletinMessage: response.data.bulletinMessage, bulletinTitle: response.data.bulletinTitle, note: response.data.note });
            locked = response.data.locked;
          } else {
            setDataError("Something was wrong in our system.");
          }
        })
        .catch((error) => {
          setDataError(apiReponseError(error, "App Status information missing."));
        });
    } catch (e) {
      setDataError(apiRequestError(e, "Something was wrong in our system."));
    }
    return locked;
  };

  // Get esp jobs status information
  const getESPJobs = async (): Promise<boolean> => {
    return getESPJobs2(internal);
  };

  const getESPJobs2 = async (isInternal): Promise<boolean> => {
    if (!isInternal) {
      return false;
    }

    writeLog("ESP Job", "Fetching requested data via api.", "", "");
    let success = false;
    try {
      await API.get("/api/espjobs")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setESPJobs(response.data.espJobs);
            success = true;
          } else {
            setDataError("Something was wrong in our system.");
          }
        })
        .catch((error) => {
          setDataError(apiReponseError(error, "ESP job information missing."));
        });
    } catch (e) {
      setDataError(apiRequestError(e, "Something was wrong in our system."));
    }
    return success;
  };

  // Get user actions
  const getUserActions = async (): Promise<boolean> => {
    writeLog("User", "Fetching requested data via api.", "", "");
    let success = false;

    try {
      await API.get("/api/user/actions")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setUserActionPendings(response.data.userActionPendings);
            success = true;
          } else {
            setDataError("Something was wrong in our system.");
          }
        })
        .catch((error) => {
          setDataError(apiReponseError(error, "User actions missing."));
        });
    } catch (e) {
      setDataError(apiRequestError(e, "Something was wrong in our system."));
    }

    return success;
  };

  // Get reference data
  const getReferenceLookups = async (): Promise<boolean> => {
    writeLog("Reference Lookups", "Fetching requested data via api.", "", "");
    let success = false;
    try {
      await API.get("/api/reference/lookups")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setAppSetting({
              online: true,
              meshifyUrl: response.data.meshifyUrl,
              legacyEnlistmentUrl: response.data.legacyEnlistmentUrl,
            });
            if (packageInfo.version !== response.data.sensorAdminVersion) {
              setAppVersionMisMatch(true);
            } else {
              setAppVersionMisMatch(false);
            }
            setReferenceLookups({
              countries: response.data.countries,
              clientCompanies: response.data.clientCompanies,
              deviceOwnerships: response.data.deviceOwnerships,
              skus: response.data.skus,
              newRecordDefaultId: response.data.newRecordDefaultId,
              combinedCompanyDefaultId: response.data.combinedCompanyDefaultId,
              parentCompanies: response.data.parentCompanies,
              participantFolderCount: response.data.participantFolderCount,
              programs: response.data.programs,
              vendors: response.data.vendors,
              domains: response.data.domains,
              roles: response.data.roles, 
              notificationSchemas: response.data.notificationSchemas,
              deviceLocationNotificationSchemaValidations: response.data.deviceLocationNotificationSchemaValidations,
              programBillingMethodTypes: response.data.programBillingMethodTypes,
              billableFolderTypes: response.data.billableFolderTypes,
              kits: response.data.kits,
              locationtypes: response.data.locationTypes,
              supportLevel: response.data.supportLevels, 
            });
            success = true;
          } else {
            setDataError("Something was wrong in our system.");
          }
        })
        .catch((error) => {
          setDataError(apiReponseError(error, "Countries lookup values missing."));
        });
    } catch (e) {
      setDataError(apiRequestError(e, "Something was wrong in our system."));
    }

    return success;
  };

  // Get client company information
  const getClientCompanies = async (): Promise<boolean> => {
    writeLog("Client Companies", "Fetching requested data via api.", "", "");
    let success = false;

    if (!userFunctionAccess.onboardingCompanyAdminRead && !userFunctionAccess.onboardingCompanyAdminWrite) {
      return success;
    }

    try {
      await API.get("/api/onboarding/clientcompanies")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setClientCompanies(response.data.clientCompanies);
            success = true;
          } else {
            setDataError("Something was wrong in our system.");
          }
        })
        .catch((error) => {
          setDataError(apiReponseError(error, "Company list missing."));
        });
    } catch (e) {
      setDataError(apiRequestError(e, "Something was wrong in our system."));
    }

    return success;
  };

  // Get Program information
  const getPrograms = async (): Promise<boolean> => {
    writeLog("Programs", "Fetching requested data via api.", "", "");
    let success = false;

    if (!userFunctionAccess.onboardingProgramAdminRead && !userFunctionAccess.onboardingProgramAdminWrite) {
      return success;
    }

    try {
      await API.get("/api/onboarding/programs")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setPrograms(response.data.programs);
            success = true;
          } else {
            setDataError("Something was wrong in our system.");
          }
        })
        .catch((error) => {
          setDataError(apiReponseError(error, "Program list missing."));
        });
    } catch (e) {
      setDataError(apiRequestError(e, "Something was wrong in our system."));
    }

    return success;
  };

  const setProgram360ProgramKey = async (key: string) => {
    writeLog("Onboarding Page", "Selected a program for 360 view.", key, "program");
    setProgramKey(key);
    setOnboardingProgram360Data(initialOnboardingProgram);

    if (key !== "") {
      await getProgram360Data(key);
    }
  };

  // Program 360 view
  const getProgram360Data = async (programKey: string): Promise<boolean> => {
    writeLog("Onboarding Page", "API retrieving the requested program 360 data.", programKey, "program");
    let success = false;

    setOnboardingDataRefreshInProgress(true);

    try {
      await API.get("/api/onboarding/programs/" + programKey + "/view")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setOnboardingProgram360Data(response.data?.onboardingProgram);
            success = true;
          } else {
            setDataError("Something was wrong in our system.");
          }
          setOnboardingDataRefreshInProgress(false);
        })
        .catch((error) => {
          setDataError(apiReponseError(error, "Program key is missing"));
          setOnboardingDataRefreshInProgress(false);
        });
    } catch (e) {
      setDataError(apiRequestError(e, "Something was wrong in our system."));
      setOnboardingDataRefreshInProgress(false);
    }

    return success;
  };

  // Get Kit information
  const getKits = async (): Promise<boolean> => {
    writeLog("Kits", "Fetching requested data via api.", "", "");
    let success = false;

    if (!userFunctionAccess.onboardingKitAdminRead && !userFunctionAccess.onboardingKitAdminWrite && !userFunctionAccess.onboardingKitApprover) {
      return success;
    }

    try {
      await API.get("/api/onboarding/kits")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setKits(response.data.kits);
            success = true;
          } else {
            setDataError("Something was wrong in our system.");
          }
        })
        .catch((error) => {
          setDataError(apiReponseError(error, "Kit list missing."));
        });
    } catch (e) {
      setDataError(apiRequestError(e, "Something was wrong in our system."));
    }

    return success;
  };

  // Get admin users information
  const getAdminUsers = async (): Promise<boolean> => {
    writeLog("Admin Users", "Fetching requested data via api.", "", "");
    let success = false;

    if (!userFunctionAccess.userPermissionAdmin) {
      return success;
    }

    try {
      await API.get("/api/admin/users")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setAdminUsers(response.data.adminUsers);
            success = true;
          } else {
            setDataError("Something was wrong in our system.");
          }
        })
        .catch((error) => {
          setDataError(apiReponseError(error, "Admin user list missing."));
        });
    } catch (e) {
      setDataError(apiRequestError(e, "Something was wrong in our system."));
    }

    return success;
  };

  // Get SKU information
  const getSKUs = async (): Promise<boolean> => {
    writeLog("SKUs", "Fetching requested data via api.", "", "");
    let success = false;

    if (!userFunctionAccess.skuAdminRead && !userFunctionAccess.skuAdminWrite) {
      return success;
    }

    try {
      await API.get("/api/onboarding/skus")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setSKUs(response.data.skus);
            success = true;
          } else {
            setDataError("Something was wrong in our system.");
          }
        })
        .catch((error) => {
          setDataError(apiReponseError(error, "SKU list missing."));
        });
    } catch (e) {
      setDataError(apiRequestError(e, "Something was wrong in our system."));
    }

    return success;
  };

  // Get device location information
  const getDeviceLocations = async (): Promise<boolean> => {
    writeLog("Device Location", "Fetching requested data via api.", "", "");
    let success = false;

    if (!userFunctionAccess.deviceLocationRead && !userFunctionAccess.deviceLocationWrite) {
      return success;
    }

    try {
      await API.get("/api/onboarding/devicelocations")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setDeviceLocationGroup(response.data.deviceLocationGroup);
            success = true;
          } else {
            setDataError("Something was wrong in our system.");
          }
        })
        .catch((error) => {
          setDataError(apiReponseError(error, "Device location list missing."));
        });
    } catch (e) {
      setDataError(apiRequestError(e, "Something was wrong in our system."));
    }

    return success;
  };

  // Get pending enrollment companies
  const getPendingEnrollmentCompanies = async (): Promise<boolean> => {
    writeLog("Pending Enrollment Companies", "Fetching requested data via api.", "", "");
    let success = false;

    if (!userFunctionAccess.pendingEnrollmentRead && !userFunctionAccess.pendingEnrollmentWrite) {
      return success;
    }

    try {
      await API.get("/api/pendingenrollment/companies")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setPendingEnrollmentCompanies(response.data.pendingCompanies);
            success = true;
          } else {
            setDataError("Something was wrong in our system.");
          }
        })
        .catch((error) => {
          setDataError(apiReponseError(error, "Pending enrollment companies list missing."));
        });
    } catch (e) {
      setDataError(apiRequestError(e, "Something was wrong in our system."));
    }

    return success;
  };

  // Get enrollment batches
  const getEnrollmentBatches = async (): Promise<boolean> => {
    writeLog("Enrollment Batches", "Fetching requested data via api.", "", "");
    let success = false;

    setEnrollmentBatches([]);
    if (!userFunctionAccess.preEnrollmentBatchAdminRead && !userFunctionAccess.preEnrollmentBatchAdminWrite) {
      return success;
    }

    try {
      await API.get("/api/enrollment/batch/files")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setEnrollmentBatches(response.data.enrollmentBatches);
            success = true;
          } else {
            setDataError("Something was wrong in our system.");
          }
        })
        .catch((error) => {
          setDataError(apiReponseError(error, "Enrollment batch list missing."));
        });
    } catch (e) {
      setDataError(apiRequestError(e, "Something was wrong in our system."));
    }

    return success;
  };

  // Get user default routing paths
  const getAppRoutePaths = async (): Promise<boolean> => {
    writeLog("App Routing", "Fetching requested data via api.", "", "");
    let success = false;
    try {
      await API.get("/api/admin/users/routes")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setAppRoutePaths(response.data.routePaths);

            let pagePaths: AppPagePath[] = [];

            pagePaths = getAppRoutePagePaths("Onboarding", response.data.routePaths);
            if (pagePaths !== undefined && pagePaths.length > 0) {
              setOnboardingPagePathName(pagePaths[0].title);
            }

            setJobPagePathName("Overview");

            success = true;
          } else {
            setDataError("Something was wrong in our system.");
          }
        })
        .catch((error) => {
          apiReponseError(error, "Route information missing.");
        });
    } catch (e) {
      apiRequestError(e, "Something was wrong in our system.");
    }

    return success;
  };

  const setEnlistmentKeys = (paramEnlistmentPartnerKey: string, paramEnlistmentProgramKey: string, paramEnlistmentStatus: string) => {
    setEnlistmentPartnerKey(paramEnlistmentPartnerKey);
    setEnlistmentProgramKey(paramEnlistmentProgramKey);
    setEnlistmentStatus(paramEnlistmentStatus);
  };

  // Get Enlistment partner & program information
  const getEnlistmentPartners = async (): Promise<boolean> => {
    writeLog("Enlistment Partners", "Fetching requested data via api.", "", "");
    let success = false;

    if (!userFunctionAccess.enlistmentAdminRead && !userFunctionAccess.enlistmentAdminWrite) {
      return success;
    }

    try {
      await API.get("/api/enlistmentadmin/partners")
        .then(async (response) => {
          if (isValidJSONString(response.data)) {
            setEnlistmentPartners(response.data.enlistmentPartners);
            success = true;
          } else {
            setDataError("Something was wrong in our system.");
          }
        })
        .catch((error) => {
          setDataError(apiReponseError(error, "Enlistment partner & program list missing."));
        });
    } catch (e) {
      setDataError(apiRequestError(e, "Something was wrong in our system."));
    }

    return success;
  };

  // Clear user token and reset authentication indicator
  const clearToken = () => {
    localStorage.removeItem("AuthToken");
    setIsUserAuthenticated(false);
    //setUserAuthToken(initialAppAuthToken);
  };

  const logoff = () => {
    clearToken();
  };

  // App context provider (using in index.js)
  return (
    <AppContext.Provider
      value={{
        adminUsers,
        appStatus,
        appDataReady,
        appReady,
        appRoutePaths,
        appSetting,
        appVersionMisMatch,
        checkAutoLogin,
        clientCompanies,
        contentDataLoading,
        dataError,
        deviceLocationGroup,
        enlistmentPartnerKey,
        enlistmentPartners,
        enlistmentProgramKey,
        enlistmentStatus,
        espJobs,
        enrollmentBatches,
        hideAlert,
        internal,
        isUserAuthenticated,
        jobPagePathName,
        kits,
        logoff,
        onboardingDataRefreshInProgress,
        onboardingPagePathName,
        onboardingProgram360Data,
        pendingEnrollmentCompanies,
        programKey,
        programs,
        referenceLookups,
        refreshData,
        replacementOrders,
        setAppReady,
        savesEntityKey,
        setSavesEntityKey,
        setEnlistmentKeys,
        setJobPagePathName,
        setOnboardingPagePathName,
        setProgram360ProgramKey,
        setReplacementOrders,
        setSubscriptions,
        setThemeType,
        showAlert,
        skus,
        snackbarAlertOpen,
        snackbarAlertProps,
        subscriptions,
        themeType,
        user,
        userFunctionAccess,
        userActionPendings,
        validateLoginUser,
        writeLog,
        userSelectedProgramCodesNote
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
